/**
 * Kling 结果 videoUrl 拉取为 Blob，供 IndexedDB 本地缓存；失败时由调用方仅带 url 完成。
 */
export function downloadKlingResultVideoBlob(videoUrl) {
  return fetch(String(videoUrl || ''), { mode: 'cors' })
    .then(function (res) {
      if (!res.ok) return Promise.reject(new Error('download video failed: HTTP ' + res.status))
      return res.blob()
    })
    .then(function (blob) {
      if (!blob || !blob.size) return Promise.reject(new Error('download video failed: empty blob'))
      return blob
    })
}
